import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import {default as Vuedals} from 'vuedals'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import Paginate from 'vuejs-paginate'
import datepickerOptions from './datepicker'
import VueYandexMetrika from 'vue-yandex-metrika'
import { apiTokenVerify } from '@/api/auth'
import Spinner from '@/components/Spinner'
import { errorMixin, checkMobileMixin, checkSystemChangesMixin } from '@/mixins'

/**
 *  Вызываем необходимые плагины.
 *
 *  ElementUI для использования компонентов UI-библиотеки.
 *  @see {@link https://github.com/MikaelEdebro/vue-airbnb-style-datepicker}
 *  Подключаем русскую локаль.
 */
Vue.use(ElementUI)
locale.use(lang)

/**
 *  Vuedals для создания конфигурируемых модальных окон.
 *  @see {@link https://github.com/MikaelEdebro/vue-airbnb-style-datepicker}
 */
Vue.use(Vuedals)

/**
 *  Плагин календаря.
 *  @see {@link https://github.com/MikaelEdebro/vue-airbnb-style-datepicker}
 */
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

/**
 *  Глобально региструем компонент пагинации, используемый на странице 'Выгрузка'.
 *  !Примечание: возможно потребуется подключить пагинацию где-то ещё, поэтому регистрируем глобально.
 *  @see {@link https://github.com/lokyoung/vuejs-paginate}
 *
 */
Vue.component('paginate', Paginate)

/**
 *  VueYandexMetrika для отслеживания метрики только на продакшен сервере.
 *  @see {@link https://github.com/vchaptsev/vue-yandex-metrika}
 */
Vue.use(VueYandexMetrika, {
  id: 53804905,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    clickmap: true,
    trackLinks: true,
    webvisor: true,
    trackHash: true
  }
})

/**
 *  Регистрируем компонент Spinner и миксин глобально,
 *  чтобы не подключать их в тех компонентах, где он будет использоваться.
*/
Vue.component('spinner', Spinner)
Vue.mixin(errorMixin)
Vue.mixin(checkMobileMixin)
Vue.mixin(checkSystemChangesMixin)
Vue.config.productionTip = false

/**
 *  На мобильных устройствах при получении фокуса элементом select
 *  виртуальная клавиатура появляется только после второго клика по select.
 *  Ниже фикс. Решение отсюда:
 *  @see {@link https://github.com/ElemeFE/element/issues/11397}
 *  TODO: Временно отключил, нужно проверить работу всех select.
 */
/* ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  return !(this.filterable || this.multiple || !isIE) && !this.visible
}
export default ElementUI  */

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    document.title = to.meta.title ? to.meta.title : 'WiFi Бизнес от Уфанет'
    if (!store.state.user.isAuth) {
      next({ path: '/auth' })
    } else {
      next()
      /**
       *  На внутренних страницах проверяем актульность токена.
       *  Если токен невалидный, отправляем на форму авторизации.
      */
      apiTokenVerify(store.state.user.token)
        .catch(() => {
          store.commit('LOGOUT')
          next({ path: '/auth' })
        })
    }
  } else {
    /**
     *  Не показываем страницу авторизации если уже авторизованы.
     *  То есть без этого условия возможен переход на страницу авторизации,
     *  в случае если набрать в адресной строке `/auth`.
    */
    if (to.path.indexOf('auth') !== -1 && store.state.user.isAuth) {
      if (this.isMobileDevice) {
        next({ path: '/home' })
      } else {
        next({ path: '/statistics' })
      }
    } else {
      next()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js